import React, {memo} from "react";

import useOrgTheme from "Hooks/useOrgTheme";

/**
 * `withTheme` HOC wrapper
 *
 * Makes the active state theme object available on a component as `theme`.
 *
 * @package HOPS
 * @subpackage Hoc
 * @copyright Heritage Operations Processing Limited
 */
const withOrg = Component => {
	return memo(props => {
		const theme = useOrgTheme();
		return <Component
			{...props}
			theme={theme} />;
	});
};

export default withOrg;
